
import {IUserLogEntryBuilder} from './i.user.log.entry.builder';
import {IUserLogEntryOptions} from './i.user.log.entry.options';

/**
 *
 * @class BuildImpliedBuilder
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      May 2021
 *
 */
export class BuildImpliedBuilder implements IUserLogEntryBuilder {

  /** convert raw MongoDB user log entry into data that can construct a tree node */
  build(data: any, args: IUserLogEntryOptions): any {

    const u:      string = data._id.match(/^build-implied-(.*)/i)[1];
    const dir:    string = data.dd;

    return {
      id:              data._id,
      seq:             parseInt(data.seq),
      name:            `Build implied: [${data.l.k}] ${data.l.n} ${dir} Track: ${data.tk.t}...`,
      hasChildren:     args.hasChildren,
      isExpanded:      args.isExpanded,
      type:            'build-implied',
      children:        args.children,
      parent:          args.parent,
      kids:            data.ch,
      tags:            data.tg,
      label:           data.lb,
      pkey:            data.pa,
      direction:       data.dd,
      kind:            data.l.k,
      sIndex:          data.l.sx,
      index:           data.l.ix,
      u:               data._id
    };

  }
}
